import { Form, Skeleton } from "antd";
import { useThrottleFn } from "ahooks";

import { useEditorContext } from "../EditorContext";
import TeaserConf from "../Teaser/TeaserConf";


export default () => {
  const [form] = Form.useForm();
  const { shareRefs, state } = useEditorContext();

  const { root } = state;

  const { run: handleSettingChange } = useThrottleFn(
    (_, data) => {
      setTimeout(() => {
        form.validateFields().then(() => {
          Object.assign(root.extraComponents.teaser.data, data)
          shareRefs.updateTeaserContent(data);
        });

      });
    },
    { wait: 200 }
  );

  if (!root || !root.extraComponents.teaser) {
    return <Skeleton active />
  }

  return (
    <Form
      form={form}
      initialValues={{
        ...root.extraComponents.teaser.data,
      }}
      onFinish={(values) => {
        Object.assign(root.extraComponents.teaser.data, values);
        handleSettingChange(null, values)
      }}
      onValuesChange={(val) => {
        Object.assign(root.extraComponents.teaser.data, val);
        handleSettingChange(val);
      }}
      layout="vertical"
      style={{ marginLeft: 20, marginRight: 20 }}
      className="config-form"
    >
      <TeaserConf />
    </Form>
  );
};